<template lang="html">

  <section class="panel-aucun-evenement">
    <div class="section">
      <div class="searchNofound">
          <img src="../assets/img/no_result.png" alt="" srcset="">
          <h4>Aucun resultat trouvé</h4>
          <p>Nous n’avons trouvé aucun evenement en cours pour cette catégorie.<br>
              Veuillez réessayez plus tard.</p>
          <!--<a class="btn btn-darkblue font-weight-bold" href="#" role="button">Rechercher a nouveau</a>-->
      </div>
    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'panel-aucun-evenement',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>
